<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'

export default{
  components: {
    [Dialog.name]: Dialog
  },
  data(){
    return {

    }
  },
  methods: {
    showDialog(){
      Dialog.alert({
        title: '提示',
        message: '出错了，请稍后再试～',
        showConfirmButton: false,
        showCancelButton: false
      }).then(() => {
        // on close
      });
    }
  },
  mounted(){
    this.showDialog()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}

</style>
